module.exports = __webpack_public_path__ + "img/tile-fnb5.abe43d0b.jpg";